export const NOTIFY_PEOPLE_PATH = '/admin/orchestration/notifications/new';

export interface NotifyPeopleParams {
  eventKey: string;
  sourceProcessDefinitionKey?: string | null;
  priority?: string | null;
}

export function notifyPeoplePriorityForEvent(eventKey: string): string {
  return eventKey.trim() === 'assignment.failed' ? 'Critical' : 'Normal';
}

export function notifyPeopleQueryParams(params: NotifyPeopleParams): Record<string, string> {
  const query: Record<string, string> = {
    eventKey: params.eventKey,
    priority: params.priority?.trim() || notifyPeoplePriorityForEvent(params.eventKey),
  };
  const source = params.sourceProcessDefinitionKey?.trim();
  if (source) {
    query['sourceProcessDefinitionKey'] = source;
  }
  return query;
}
